import { useState } from "react";
import {
  Edit,
  ImageInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "react-admin";
import ApcMediaField from "../../common/ApcMediaField";

const year = [
  
  {
    id: "Y2025",
    label: "2025",
  },
];

const source = [
  {
    id: "AHA",
    label: "AHA",
  },
  {
    id: "AADA",
    label: "AADA",
  },
];
const galleryType = [
  {
    id: "Video",
    label: "Video",
  },
  {
    id: "Image",
    label: "Image",
  },
  {
    id: "Pdf",
    label: "Pdf",
  },
];

const EditGallery = (props: any) => {
  const [mediaType, setMediaType] = useState<string | null>(null);

  const handleMediaTypeChange = (event: any) => {
    setMediaType(event.target.value);
  };
  return (
    <Edit {...props} title={<title />}>
      <SimpleForm>
        <ImageInput
          label="Thumbnail"
          source="thumbnail"
          fullWidth
          accept="image/*"
          format={(src) =>
            typeof src == "string" ? { src, type: props } : src
          }
        >
          <ApcMediaField source="src" />
        </ImageInput>

        <TextInput label="Title" source="title" multiline fullWidth required />
        <TextInput
          label="Description"
          source="description"
          multiline
          fullWidth
          required
        />

        <SelectInput
          source="year"
          label="Year"
          defaultValue={{ id: "Y2023", label: "2023" }}
          choices={year}
          optionText="label"
          optionValue="id"
        />

        <SelectInput
          source="source"
          label="Source"
          choices={source}
          optionText="label"
          optionValue="id"
        />
        <TextInput
          source="mediaType"
          label="Media Type"
          defaultValue={"Image"}
          disabled
          hidden={true}
        />
        <TextInput
          label="Priority"
          source="priority"
          multiline
          fullWidth
          required={true}
        />
        <ImageInput
          label="Images"
          source="images"
          fullWidth
          multiple
          accept="image/*"
          parse={(src) => {
            const value = Array.isArray(src) ? src : [src];
            return value.map((item) => {
              if (item instanceof File)
                return {
                  url: {
                    rawFile: item,
                    src: URL.createObjectURL(item),
                    title: item.name,
                  },
                };
              return item;
            });
          }}
          format={(src) => {
            if (!src) return src;
            const value = Array.isArray(src) ? src : [src];
            const result = value.map((item) => {
              if (typeof item?.url == "string") return item;

              const url = item?.url?.src || item?.url || item;
              return { url };
            });

            return result;
          }}
          isRequired={true}
        >
          <ApcMediaField source="url" />
        </ImageInput>
      </SimpleForm>
    </Edit>
  );
};

export default EditGallery;
